module.exports = __webpack_public_path__ + "media/site/images/case_studies/sensor_cloud/dashboard2-08a8216307ef1d0c8bd5e925b8ba92d2.png";